import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AuthService from "../../../../api/AuthService";
import { useAlert } from "../../../../context/AlertContext";
import PayslipPage from "../../../../entities/DashboardPage/HRModule/PayrollPayslip/Home";
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";
import { getBlobErrorMessage } from "../../../../utils/blobError";

const Payslips = () => {
  const [loading, setLoading] = useState();
  const { showAlert } = useAlert();
  const { state } = useLocation();
  const { item, payrollData } = state || {};
  const [deductionType, setDeductionType] = useState([]);
  const [pensiondata, setpensiondata] = useState([]);
  const [payslip, setPayslip] = useState([]);
  const [allowanceData, setallowanceData] = useState([]);
  const [levieData, setLevieData] = useState([]);
  const [fringeData, setFringeData] = useState([]);
  const [loanData, setLoanData] = useState([]);
  const [deductionData, setDeductionData] = useState([]);
  const [leaveData, setLeaveData] = useState([]);
  const [contribution, setContribution] = useState([]);
  const [leaveType, setLeaveType] = useState([]);
  const [slaryData, setSalaryData] = useState(item);
  const [leviesType, setLeviesType] = useState([]);

  useEffect(() => {
    if (item?._id) {
      getPayrollPayslip(item?._id);
      getPayslipSetting();
      getLevieList();
      getLeaveType();
      getDeductionType();
      getLeviesType()
      getLeave()
    }
  }, []);

  const getPayrollPayslip = async (id) => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getSalaryInfoData(id);
      if (result?.success) {
        setSalaryData(result?.data?.[0]);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const handleUpdate = async (user, travelValue) => {
    setLoading(true);
    try {
      const result = await AuthService.handlePayslip(
        slaryData?._id,
        user,
        "",
        travelValue
      );
      if (result?.success === true) {
        setLoading(false);
        getPayrollPayslip(item?._id);

        showAlert(result?.message, "success");
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };
  const getPensionList = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getPensionList(
        item?._id,
        payrollData?._id
      );
      if (result?.success) {
        setpensiondata(result?.data?.pension);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const getAllowanceList = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getAllowanceList(
        item?.employee?._id,
        payrollData?._id
      );
      if (result?.success) {
        setallowanceData(result?.data?.allowance);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const getLevieList = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getLevieList(
        item?.employee?._id,
        payrollData?._id
      );
      if (result?.success) {
        setLevieData(result?.data?.levie);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const getFringeList = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getFringeList(
        item?.employee?._id,
        payrollData?._id
      );
      if (result?.success) {
        setFringeData(result?.data?.fringes);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const getLoanList = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getLoanPayslip(
        item?.employee?._id,
        payrollData?._id
      );
      if (result?.success) {
        setLoanData(result?.data?.loans);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const getDeductionList = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getDeductionPayslip(payrollData?._id);
      if (result?.success) {
        setDeductionData(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const getLeave = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getLeavePayslip(
        item?.employee?._id,
        slaryData?.payroll?.start,
        slaryData?.payroll?.end
      );
      if (result?.success) {
        setLeaveData(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const handlePension = async (id, type, amount, payrollId, employeeId) => {
    setLoading(true);
    try {
      const result = await AuthService.handlePension(
        id,
        type,
        amount,
        payrollId,
        employeeId
      );
      if (result?.success) {
        showAlert(result?.message, "success");
        setLoading(false);
        getPensionList();
      } else {
        showAlert(result?.message, "success");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const handleFringe = async (id, type, amount, payrollId, employeeId) => {
    setLoading(true);
    try {
      const result = await AuthService.handleFringe(
        id,
        type,
        amount,
        payrollId,
        employeeId
      );
      if (result?.success) {
        showAlert(result?.message, "success");
        setLoading(false);
        getFringeList();
      } else {
        showAlert(result?.message, "success");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const handleAllowance = async (id, type, amount, payrollId, employeeId) => {
    setLoading(true);
    try {
      const result = await AuthService.handleAllowance(
        id,
        type,
        amount,
        payrollId,
        employeeId
      );
      if (result?.success) {
        showAlert(result?.message, "success");
        setLoading(false);
        getAllowanceList();
      } else {
        showAlert(result?.message, "success");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const handleLevie = async (id, payrollId, employeeId, rateValue) => {
    setLoading(true);
    try {
      const result = await AuthService.handleLevie(
        id,
        payrollId,
        employeeId,
        rateValue,
      );
      if (result?.success) {
        showAlert(result?.message, "success");
        setLoading(false);
        getLevieList();
        getPayrollPayslip(item?._id);
      } else {
        showAlert(result?.message, "success");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const handleLeave = async (
    id,
    leaveFrom,
    leaveTo,
    leaveType,
    payrollId,
    employeeId
  ) => {
    setLoading(true);
    try {
      const result = await AuthService.handleLeave(
        id,
        leaveFrom,
        leaveTo,
        leaveType,
        payrollId,
        employeeId
      );
      if (result?.success) {
        showAlert(result?.message, "success");
        setLoading(false);
        getLeave();
      } else {
        showAlert(result?.message, "success");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const handleLoanPayslips = async (
    id,
    payrollId,
    employeeId,
    payload,
    loanId
  ) => {
    setLoading(true);
    try {
      const result = await AuthService.handleLoanPayslip(
        id,
        payrollId,
        employeeId,
        payload,
        loanId
      );
      if (result?.success) {
        showAlert(result?.message, "success");
        setLoading(false);
        getLoanList();
        getPayrollPayslip(item?._id);
      } else {
        showAlert(result?.message, "success");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const handleDeductionPayslips = async (
    id,
    payrollId,
    employeeId,
    deduction,
  ) => {
    setLoading(true);
    try {
      const result = await AuthService.handleDeductionPayslip(
        id,
        payrollId,
        employeeId,
        deduction
      );
      if (result?.success) {
        showAlert(result?.message, "success");
        setLoading(false);
        getPayrollPayslip(item?._id);
        getDeductionList();
      } else {
        showAlert(result?.message, "error");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const getPayslipSetting = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getPayslipSetting();
      if (result?.success) {
        setPayslip(result?.data);

        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getContribution = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getContributionEdit(
        item?.employee?._id,
        payrollData?._id
      );
      if (result?.success) {
        setContribution(result?.data?.contribution);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getLeaveType = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAccountLeaveType();
      if (result?.success) {
        setLeaveType(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getDeductionType = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getDeductionType();
      if (result?.success) {
        setDeductionType(result?.data?.deductions);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getLeviesType = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getLeviesType();
      if (result?.success) {
        setLeviesType(result?.data?.levies);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleExportPayslip = async (salaryId) => {
    if (!salaryId) {
      showAlert("Salary ID is required", "error");
      return;
    }

    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.exportPayslip(salaryId);

      if (!result) {
        LoaderHelper.loaderStatus(false);
        showAlert("Export failed", "error");
        return;
      }

      // Create blob from result (axios with responseType: 'blob' returns Blob in response.data)
      const downloadError = await getBlobErrorMessage(result);
      if (downloadError) {
        LoaderHelper.loaderStatus(false);
        showAlert(downloadError, "error");
        return;
      }
      const blob = new Blob([result], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = window.document.createElement("a");
      link.href = url;
      link.setAttribute("download", `payslip_${salaryId}.pdf`);
      window.document.body.appendChild(link);
      link.click();
      window.document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      showAlert("Payslip exported successfully", "success");
      LoaderHelper.loaderStatus(false);
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      showAlert(error?.message || "Export failed", "error");
    }
  };

  return (
    <PayslipPage
      getLeave={getLeave}
      addDeduction={handleDeductionPayslips}
      addLeave={handleLeave}
      leaveData={leaveData}
      getLoanList={getLoanList}
      getDeductionList={getDeductionList}
      deductionData={deductionData}
      loanData={loanData}
      addPension={handlePension}
      addFringe={handleFringe}
      addAllowance={handleAllowance}
      addLevie={handleLevie}
      salaryData={slaryData}
      handleUpdate={handleUpdate}
      loading={loading}
      getPensionList={getPensionList}
      pensionData={pensiondata}
      getAllowanceList={getAllowanceList}
      allowanceData={allowanceData}
      getLevieList={getLevieList}
      levieData={levieData}
      getFringeList={getFringeList}
      fringeData={fringeData}
      handleLoanPayslip={handleLoanPayslips}
      payslip={payslip}
      getContribution={getContribution}
      contribution={contribution}
      getLeaveType={leaveType}
      deductionType={deductionType}
      leviesType={leviesType}
      handleExportPayslip={handleExportPayslip}
    />
  );
};

export default Payslips;
